import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  DashboardService,
  BaseResolverService,
  DashboardKpiService
} from '@tmhcc-ng-lib/data-service';
import { DashboardComponent } from './dashboard.component';
import { DashboardContentService } from '@tmhcc-ng-lib/content-service';
import { BadgeModule } from '@tmhcc-ng-lib/framwork/badge';
import { CommonModule } from '@angular/common';
import { CoreInputsModule } from '@tmhcc-ng-lib/framwork/core-inputs';
import { TabsComponent } from '../tabs/tabs.component';
import { GridModule } from '@tmhcc-ng-lib/framwork/grid';
import { AccordionControlModule } from '@tmhcc-ng-lib/framwork/accordion-control';
import { ClickOutsideModule } from 'ng-click-outside';
import { NgbdCarouselBasicModule } from '../carousel/carousel.module';
const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    resolve: {
      dashboard: BaseResolverService
    },
    data: {
      state: 'dashboard'
    }
  }
];
@NgModule({
  providers: [
    DashboardService,
    DashboardKpiService,
    DashboardContentService,
    BaseResolverService
  ],
  declarations: [DashboardComponent, TabsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    BadgeModule,
    CoreInputsModule,
    GridModule,
    AccordionControlModule,
    ClickOutsideModule,
    NgbdCarouselBasicModule
  ],
  exports: [RouterModule]
})
export class DashboardModule {}
